import { render } from "./GoBoard.vue?vue&type=template&id=1b6418be&scoped=true"
import script from "./GoBoard.vue?vue&type=script&lang=js"
export * from "./GoBoard.vue?vue&type=script&lang=js"

import "./GoBoard.vue?vue&type=style&index=0&id=1b6418be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6418be"]])

export default __exports__